var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeolocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#geolocation_svg__clip0_17469_113653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 14c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10zm0 16c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6zm22-8h-2.1C42.958 12.566 35.434 5.04 26 4.1V2a2 2 0 10-4 0v2.1C12.566 5.04 5.04 12.566 4.1 22H2a2 2 0 100 4h2.1c.942 9.434 8.466 16.96 17.9 17.9V46a2 2 0 104 0v-2.1c9.434-.942 16.96-8.466 17.9-17.9H46a2 2 0 100-4zM24 40c-8.822 0-16-7.178-16-16S15.178 8 24 8s16 7.178 16 16-7.178 16-16 16z",
    fill: "#EC6338"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "geolocation_svg__clip0_17469_113653"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
}
export default SvgGeolocation;